const languages = {
    cn: {
        pageLength: ' ',
        pageInfo: `#pageNumber# / #totalPage# （#totalRow#）`,
        first: '<<',
        previous: '«',
        next: '»',
        last: '>>'
    },
    en: {
        pageLength: 'Page length ',
        pageInfo: 'Current #pageNumber# / #totalPage# （total #totalRow# records）',
        first: 'First',
        previous: '«',
        next: '»',
        last: 'Last'
    },
    jp: {
        pageLength: 'ページごとの記録数',
        pageInfo: '現在の第 #pageNumber# / #totalPage# ページ（全部で #totalRow# 条の記録）',
        first: 'トップページ',
        previous: '«',
        next: '»',
        last: '尾のページ'
    }
};

export default languages;